import { CaretDownOutlined } from '@ant-design/icons';
import { Button, Divider, Dropdown, Row, Space, theme, Typography } from 'antd';
import React from 'react';

import type { MassActionsDropdownType } from '@app/components/MassActionsDropdown/MassActionsDropdown.types';
import { PREFIX } from '@app/constants';

const { useToken } = theme;
const { Text } = Typography;

export const MassActionsDropdown: MassActionsDropdownType = ({
  items,
  selectionCount,
  data,
  buttonDataTestId = '',
}) => {
  const { token } = useToken();

  if (!data.length) {
    return null;
  }

  const { colorBgElevated, borderRadiusLG, boxShadowSecondary } = token;

  return (
    <Row className={`${PREFIX}actions-dropdown`} justify="end">
      <Dropdown
        placement="topLeft"
        menu={{ items }}
        popupRender={(menu) => (
          <div
            style={{
              backgroundColor: colorBgElevated,
              borderRadius: borderRadiusLG,
              boxShadow: boxShadowSecondary,
            }}
          >
            {Boolean(selectionCount) && (
              <>
                <Space style={{ padding: '8px 16px' }}>
                  <Text data-testid="selected-rows-count">
                    Выбрано строк: {selectionCount}
                  </Text>
                </Space>
                <Divider className="mg-0" />
              </>
            )}
            {React.cloneElement(menu as React.ReactElement, {
              style: { boxShadow: 'none' },
            })}
          </div>
        )}
      >
        <Button type="primary" data-testid={buttonDataTestId} size="small">
          Действия
          <CaretDownOutlined />
        </Button>
      </Dropdown>
    </Row>
  );
};
